import {
  get,
} from '@/utils/request';

const url = 'trial-payments';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function getDailyTrialPayments({
  page, store_id, report_date,
}) {
  return get({
    url: `${url}/daily`,
    data: {
      page,
      store_id,
      report_date: report_date,
    },
  });
}
